// Named exports only: the style recipe is shared with the pickers by direct
// import, never through the public barrel.
export { Card } from './card';
export type { CardProps } from './card';
